import { ButtonActor } from '../../actors';
import { Card } from 'components/atoms';
import { ChevronRightIcon } from 'components/icons';
import { IconElement } from 'types/IconElement';
import { Intent } from 'components/atoms/Card/Card';
import classes from 'classnames';
import React, { memo, PropsWithChildren } from 'react';
import styles from './OptionCardButton.module.scss';

export type Props = {
  className?: string;
  classNameTitle?: string;
  classNameEtiquette?: string;
  classNameIconContainer?: string;
  etiquette?: string;
  intent?: Intent;
  leftIcon?: IconElement;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  subtitle?: React.ReactNode;
  title?: React.ReactNode;
  dataTest?: string;
};

export default memo(function OptionCardButton({
  etiquette,
  className,
  classNameEtiquette,
  classNameTitle,
  classNameIconContainer,
  intent = 'none',
  leftIcon,
  onClick,
  subtitle,
  title,
  dataTest,
}: PropsWithChildren<Props>) {
  return (
    <ButtonActor
      buttonProps={{
        className: classes(styles['button-wrapper']),
        onClick,
        dataTest,
      }}
      analytics={{
        description: `Verification option card: ${title}`,
      }}
    >
      <Card className={classes(styles.container, className)} intent={intent}>
        {etiquette && (
          <div
            className={classes(styles.etiquette, classNameEtiquette)}
            data-test="css-Card-Recommended"
          >
            {etiquette}
          </div>
        )}

        {leftIcon && (
          <div
            className={classes(
              styles['left-icon-container'],
              classNameIconContainer,
            )}
          >
            {leftIcon}
          </div>
        )}

        <div className={classes(styles['text-content'])}>
          {title && (
            <span
              className={classes(classNameTitle, styles.title)}
              data-test="css-Card-Title"
            >
              {title}
            </span>
          )}

          {subtitle && (
            <span className={classes(styles.subtitle)}>{subtitle}</span>
          )}
        </div>

        <ChevronRightIcon className={styles.arrow} />
      </Card>
    </ButtonActor>
  );
});
